import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { routeTree } from "./routeTree.gen.ts";
import {createRouter, RouterProvider} from "@tanstack/react-router";
import {UserProvider} from "./context/UserContext.tsx";
import {RecordingsProvider} from "./context/RecordingsContext.tsx";
import {AlertsProvider} from "./context/AlertsContext.tsx";
import {NoteTypesProvider} from "./context/NoteTypesContext.tsx";
import {PatientsProvider} from "./context/PatientsContext.tsx";
import {OrganizationProvider} from "./context/OrganizationContext.tsx";
import './utils/i18n';
import './utils/dayjs';
import Sentry from './utils/sentry';
import {WebsocketProvider} from "./context/WebsocketContext.tsx";
import {AudioRecordingProvider} from "./context/AudioRecordingContext.tsx";

const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<div className="p-8 text-center">Something went wrong. Please refresh the page.</div>}>
      <AlertsProvider>
        <UserProvider>
          <OrganizationProvider>
            <NoteTypesProvider>
              <PatientsProvider>
                <AudioRecordingProvider>
                  <RecordingsProvider>
                    <WebsocketProvider>
                      <RouterProvider router={router}/>
                    </WebsocketProvider>
                  </RecordingsProvider>
                </AudioRecordingProvider>
              </PatientsProvider>
            </NoteTypesProvider>
          </OrganizationProvider>
        </UserProvider>
      </AlertsProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
